define('multiSelectDropdownView',[
  'jquery',
  'underscore'
], function ($, _) {
  'use strict';

  function MultiSelectDropdown(options) {
    this.options = options || {};
    this.items = this.options.items || [];
    this.selection = (this.options.selection || []).slice();
    this.placeholder = this.options.placeholder || 'All';
    this.countLabel = this.options.countLabel || 'selected';
    this.clearLabel = this.options.clearLabel || 'Clear';
    this.applyLabel = this.options.applyLabel || 'Validate';
    this.loadingLabel = this.options.loadingLabel || 'Loading...';
    this.searchPlaceholder = this.options.searchPlaceholder || 'Filter...';
    this.onApply = this.options.onApply || function () {};
    this._open = false;
    this._outsideHandler = null;
    this.el = null;
    this.$el = null;
  }

  MultiSelectDropdown.prototype._buildToggleHtml = function () {
    var label = this.options.labelHtml ? this.options.labelHtml(this.selection) : _.escape(this._labelForSelection(this.selection));
    return '' +
      '<div class="ms-dropdown">' +
      '  <button type="button" class="js-ms-toggle ms-dropdown-toggle">' +
      '    <span class="js-ms-label ms-dropdown-toggle-label">' + label + '</span>' +
      '    <i class="fa fa-caret-down" aria-hidden="true"></i>' +
      '  </button>' +
      '</div>';
  };

  MultiSelectDropdown.prototype._buildPanelHtml = function () {
    return '' +
      '<div class="js-ms-panel ms-dropdown-panel" style="display:none;">' +
      '  <div class="ms-dropdown-search">' +
      '    <i class="fa fa-search ms-dropdown-search-icon" aria-hidden="true"></i>' +
      '    <input type="text" class="js-ms-search ms-dropdown-search-input" placeholder="' + _.escape(this.searchPlaceholder) + '" />' +
      '  </div>' +
      '  <div class="js-ms-list ms-dropdown-list"></div>' +
      '  <div class="ms-dropdown-actions">' +
      '    <button type="button" class="js-ms-clear ms-dropdown-btn ms-dropdown-btn--secondary">' + _.escape(this.clearLabel) + '</button>' +
      '    <button type="button" class="js-ms-apply ms-dropdown-btn ms-dropdown-btn--primary">' + _.escape(this.applyLabel) + '</button>' +
      '  </div>' +
      '</div>';
  };

  MultiSelectDropdown.prototype._labelForSelection = function (sel) {
    if (!sel || !sel.length) { return this.placeholder; }
    var items = this.items || [];
    var labels = _.map(sel, function (v) {
      var item = _.findWhere(items, {value: v});
      return item ? item.label : v;
    });
    return labels.join(', ');
  };

  // The list is built when the panel opens (_ensureList): a page can hold hundreds of dropdowns (one per
  // cell of a grid) and most are never opened.
  MultiSelectDropdown.prototype._ensureList = function () {
    if (this._listStale) {
      this._renderList();
    }
  };

  MultiSelectDropdown.prototype._renderList = function () {
    if (!this.$panel) { return; }
    this._listStale = false;
    this._reordered = false;
    var $list = this.$panel.find('.js-ms-list');
    if (!this.items || !this.items.length) {
      $list.html('<div class="ms-dropdown-empty">' + _.escape(this.loadingLabel) + '</div>');
      return;
    }
    var selected = this.selection || [];
    var html = [];
    for (var i = 0; i < this.items.length; i++) {
      var it = this.items[i];
      // it.disabled: shown ticked and locked (kept in the selection on apply / clear); it.hint: small text on the right
      var checked = (it.disabled || _.contains(selected, it.value)) ? 'checked' : '';
      var labelStr = String(it.label);
      var row = '' +
        '<label class="js-ms-item ms-dropdown-item' + (it.disabled ? ' ms-dropdown-item--locked' : '') + '" data-label="' + _.escape(labelStr.toLowerCase()) + '" data-index="' + i + '"' +
        (it.title ? ' title="' + _.escape(it.title) + '"' : '') + '>' +
        '  <input type="checkbox" class="js-ms-checkbox" value="' + _.escape(String(it.value)) + '" ' + checked + (it.disabled ? ' disabled' : '') + ' />' +
        '  <span>' + _.escape(labelStr) + '</span>' +
        (it.hint ? '  <span class="ms-dropdown-item-hint">' + _.escape(it.hint) + '</span>' : '') +
        '</label>';
      html.push(row);
    }
    $list.html(html.join(''));
    this._applyFilter();
  };

  // Lower case, no accents: "Écru" matches "ecru".
  var fold = function (text) {
    return String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  };

  // 0 full match, 1 starts with, 2 a word starts with, 3 contains, -1 no match.
  var matchRank = function (label, term) {
    if (label === term) { return 0; }
    if (label.indexOf(term) === 0) { return 1; }
    if ((' ' + label).indexOf(' ' + term) !== -1) { return 2; }
    return label.indexOf(term) !== -1 ? 3 : -1;
  };

  // Shows the items matching the search, the full match first (then starts with, a word starts
  // with, contains); without search, every item in its original order.
  MultiSelectDropdown.prototype._applyFilter = function () {
    if (!this.$panel) { return; }
    var term = fold((this._searchTerm || '').trim());
    var $list = this.$panel.find('.js-ms-list');
    var items = $list.children('.js-ms-item').get();
    if (!term && !this._reordered) {
      // nothing filtered nor moved: every item shown, in its order
      $(items).css('display', '');
      return;
    }
    this._reordered = !!term;
    var ranked = [];
    _.each(items, function (el) {
      var rank = term ? matchRank(fold($(el).attr('data-label')), term) : 0;
      $(el).toggle(rank >= 0);
      ranked.push({el: el, rank: rank < 0 ? 4 : rank, index: parseInt($(el).attr('data-index'), 10) || 0});
    });
    ranked.sort(function (a, b) { return term ? (a.rank - b.rank) || (a.index - b.index) : a.index - b.index; });
    _.each(ranked, function (r) { $list.append(r.el); });
  };

  MultiSelectDropdown.prototype.render = function () {
    var that = this;
    this.$el = $(this._buildToggleHtml());
    this.el = this.$el[0];
    this.$panel = $(this._buildPanelHtml());
    this._listStale = true;

    this.$el.on('click.msdd', '.js-ms-toggle', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (that._open) { that.close(); } else { that.open(); }
    });

    this.$panel.on('click.msdd', function (e) {
      e.stopPropagation();
    });

    this.$panel.on('input.msdd keyup.msdd', '.js-ms-search', function () {
      that._searchTerm = $(this).val() || '';
      that._applyFilter();
    });

    this.$panel.on('click.msdd', '.js-ms-clear', function (e) {
      e.preventDefault();
      e.stopPropagation();
      that.$panel.find('.js-ms-checkbox').each(function () { if (!this.disabled) { this.checked = false; } });
    });

    this.$panel.on('click.msdd', '.js-ms-apply', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var picked = [];
      that.$panel.find('.js-ms-checkbox').each(function () {
        if (this.checked) { picked.push($(this).val()); }
      });
      that.selection = picked;
      that._updateLabel();
      that.close();
      try { that.onApply(picked.slice()); } catch (ex) {}
    });

    return this;
  };

  MultiSelectDropdown.prototype._updateLabel = function () {
    if (!this.$el) { return; }
    if (this.options.labelHtml) {
      this.$el.find('.js-ms-label').html(this.options.labelHtml(this.selection));
    } else {
      this.$el.find('.js-ms-label').text(this._labelForSelection(this.selection));
    }
  };

  MultiSelectDropdown.prototype._positionPanel = function () {
    if (!this.$el || !this.$panel) { return; }
    var $toggle = this.$el.find('.js-ms-toggle');
    if (!$toggle.length) { return; }
    var rect = $toggle[0].getBoundingClientRect();
    var panelW = this.$panel.outerWidth() || 240;
    var panelH = this.$panel.outerHeight() || 200;
    var vw = $(window).width();
    var vh = $(window).height();
    var margin = 6;
    var left = rect.left;
    if (left + panelW > vw - 8) { left = Math.max(8, vw - panelW - 8); }
    var top = rect.bottom + margin;
    if (top + panelH > vh - 8) {
      var above = rect.top - panelH - margin;
      if (above >= 8) { top = above; }
      else { top = Math.max(8, vh - panelH - 8); }
    }
    this.$panel.css({left: left + 'px', top: top + 'px'});
  };

  MultiSelectDropdown.prototype.open = function () {
    if (!this.$el || !this.$panel || this._open) { return; }
    this._ensureList();
    // Re-sync checkboxes with current committed selection
    var selected = this.selection || [];
    this.$panel.find('.js-ms-checkbox').each(function () {
      this.checked = this.disabled || _.contains(selected, $(this).val());
    });
    // Reset filter each time the panel opens
    this._searchTerm = '';
    this.$panel.find('.js-ms-search').val('');
    this._applyFilter();
    // Append panel to the nearest modal (if any) so bootstrap's focus-trap
    // doesn't block interactions; otherwise fall back to body.
    var $host = this.$el.closest('.modal');
    if (!$host.length) { $host = $('body'); }
    $host.append(this.$panel);
    this.$panel.show();
    this.$panel.find('.js-ms-search').focus();
    this._positionPanel();
    this._open = true;
    var that = this;
    this._outsideHandler = function (evt) {
      if (!that._open) { return; }
      var panelEl = that.$panel && that.$panel[0];
      if (panelEl && (evt.target === panelEl || $.contains(panelEl, evt.target))) { return; }
      if (that.el && (evt.target === that.el || $.contains(that.el, evt.target))) { return; }
      that.close();
    };
    this._repositionHandler = function () { that._positionPanel(); };
    setTimeout(function () {
      $(document).on('click.msdd-' + that._id(), that._outsideHandler);
    }, 0);
    $(window).on('scroll.msdd-' + this._id() + ' resize.msdd-' + this._id(), this._repositionHandler);
  };

  MultiSelectDropdown.prototype.close = function () {
    if (!this.$panel) { return; }
    this.$panel.hide();
    this.$panel.detach();
    this._open = false;
    if (this._outsideHandler) {
      try { $(document).off('click.msdd-' + this._id(), this._outsideHandler); } catch (e) {}
      this._outsideHandler = null;
    }
    if (this._repositionHandler) {
      try { $(window).off('scroll.msdd-' + this._id() + ' resize.msdd-' + this._id(), this._repositionHandler); } catch (e2) {}
      this._repositionHandler = null;
    }
  };

  MultiSelectDropdown.prototype._id = function () {
    if (!this.__id) { this.__id = Math.random().toString(36).slice(2, 9); }
    return this.__id;
  };

  MultiSelectDropdown.prototype.setItems = function (items) {
    this.items = items || [];
    if (this.$el) {
      this._listStale = true;
      if (this._open) {
        this._renderList();
      }
      this._updateLabel();
    }
  };

  MultiSelectDropdown.prototype.setSelection = function (sel) {
    this.selection = (sel || []).slice();
    if (this.$el) {
      this._updateLabel();
      if (this._open && this.$panel) {
        var selected = this.selection;
        this.$panel.find('.js-ms-checkbox').each(function () {
          this.checked = _.contains(selected, $(this).val());
        });
      }
    }
  };

  MultiSelectDropdown.prototype.getSelection = function () {
    return (this.selection || []).slice();
  };

  MultiSelectDropdown.prototype.destroy = function () {
    this.close();
    if (this.$panel) {
      try { this.$panel.off('.msdd'); } catch (ePanel) {}
      this.$panel.remove();
      this.$panel = null;
    }
    if (this.$el) {
      try { this.$el.off('.msdd'); } catch (e) {}
      this.$el.remove();
      this.$el = null;
      this.el = null;
    }
  };

  return MultiSelectDropdown;
});

